import log from 'salvo-lite/log'

class DynamicFilter {
    constructor (theme, elem) {
        this.theme = theme
        this.elem = elem
        this.apply = this.elem.querySelector('[data-apply-button]')
        this.filter = this.elem.querySelectorAll('.checkbox-item')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating', this)
        for (var i = 0; i < this.filter.length; i++) {
            this.filter[i].addEventListener('click', (e) => {
                this.apply.click()
            })
        }
        log.debug(this.constructor.name, 'Initiated', this)
    }
}

export default DynamicFilter



// WEBPACK FOOTER //
// ./src/resources/scripts/components/DynamicFilter.js